import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, TextField, Link, SvgIcon, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginFlagOff, passwordChangeEmail } from "../../redux/actions/User";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./Layout";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { api } from "src/api/endpoints";
import { useForm } from "react-hook-form";

function ForgetPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [emailDisabled, setEmailDisabled] = useState(false)
    const [emailDisabledCounter, setEmailDisabledCounter] = useState(10)
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm()

  const translateError = (error) => {
    switch (error) {
        case 'EmailSendError':
            return t("views.forgetPassword.emailSendError")
        case 'ServerError': 
            return t("views.forgetPassword.serverError")
        case 'Not Found':
            return t("views.forgetPassword.emailSendError")
        case 'Unauthorized':
            return t("views.forgetPassword.emailSendError")
        default: 
            return error
    }
  }

  const onSubmit = async (data) => {
    if(email){
        setEmailDisabled(true)
        setIsLoading(true)
        try {
            const {data: apiData, status} = await api.post('/user/forgetpassword', { email: data.email })
            setIsLoading(false)
            if(status == 204) {
                toast.success(t("views.forgetPassword.forgotPassSuccess"))
                reset({email: ''})
                navigate(-1)
            }
        } catch (err) {
            setIsLoading(false)
            toast.error(translateError(err.response.data.error.message))
            setTimeout(() => {
                setEmailDisabled(false)
            }, 10000)
            for (let x = 9; x >= 0; x--){
                setTimeout(() => {
                    setEmailDisabledCounter(10-x)
                }, x*1000)
            }
        }
    }else{
        toast.error(t("views.signup.invalidEmail"))
    }
  }

  return (
    <>
        <AuthLayout>
            <Box sx={{
                width: '100%',
                maxWidth: '460px'
            }}><Button startIcon={<ChevronLeftIcon />} onClick={() => navigate(-1)}>Login</Button></Box>
            <Typography textAlign="center" maxWidth="460px" variant="h3" sx={{
                color: "#016AFE"
            }}>VCPlayer</Typography>
            <Typography textAlign="center" maxWidth="460px" variant="h4" sx={{
                color: "#313031"
            }}>SIGNAGE</Typography>
            <Typography textAlign="center" maxWidth="460px" variant="body1" sx={{
                color: "#313031"
            }}>{t("views.forgetPassword.forgotPassQuestion")}</Typography>
            <Typography textAlign="center" maxWidth="460px" variant="body2" sx={{
                color: "#313031"
            }}>{t("views.forgetPassword.forgotPassDescription")}</Typography>
            <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%', maxWidth: "460px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "20px",
            }}>
                <TextField variant="standard" {...register('email', {required: true, pattern: {
                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: t("views.signup.invalidEmail"),
                }})} label={t("views.forgetPassword.email")} type="email" fullWidth value={email} onInput={(e) => {setEmail(e.target.value)}} sx={{maxWidth: "460px"}} />
                <Typography color="warning.main">{errors.email && errors.email?.message}</Typography>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px"
                }}>
                    {isLoading ? (
                        <CircularProgress size="20px" />
                    ) : null}
                    <Button variant="contained" disabled={emailDisabled} type="submit" fullWidth sx={{
                        "&.Mui-disabled": {
                            background: "#d3d3d3ff",
                            color: "#919191ff"
                        }
                    }}>{t("views.forgetPassword.send")} {emailDisabled ? emailDisabledCounter : ''}</Button>
                </Box>
            </form>
        </AuthLayout>
    </>
  );
}

export default ForgetPassword;
